import * as React from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  title: { fontSize: "1.2rem", color: "#128bcc", fontWeight: "bold" },
  value: { fontWeight: "bold" },
});

const TotalItem = ({
  title,
  sizeTitle = 2,
  value = "",
  sizeValue = 2,
  classes,
}) => {
  return (
    <Grid container>
      <Grid xs={12 - sizeTitle - sizeValue} />
      <Grid item xs={sizeTitle}>
        <p className={classes.title}>{title}</p>
      </Grid>
      <Grid item xs={sizeValue}>
        <p className={classes.value}>{value}</p>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(TotalItem);
